module.exports = __webpack_public_path__ + "img/most.0c51d21b.jpg";